import React from 'react';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { imgPath } from '~common/utilities/ImgUrl';

import { Messages } from '../../../codegen/Localize';
import { cssClass } from '../../../style';
import { PageHeaderStyles } from './PageHeaderStyles';

const cssPrefix = 'SkipBar';

const SkipBarSpacing = '48px';

const SkipBarContainerCSSProperties: NestedCSSProperties = {
  height: 'auto',
  maxHeight: 0,
  lineHeight: SkipBarSpacing,
  paddingLeft: SkipBarSpacing,
  paddingRight: SkipBarSpacing,
  backgroundColor: '#1a699e',
  transition: 'max-height .1s ease-out',
  verticalAlign: 'middle',
};

const SkipBarContainerStyle = cssClass(cssPrefix, 'container', SkipBarContainerCSSProperties);

const SkipBarContainerOpenedStyle = cssClass(cssPrefix, 'containerOpened', {
  ...SkipBarContainerCSSProperties,
  maxHeight: SkipBarSpacing,
});

const SkipBarLinkCSSProperties: NestedCSSProperties = {
  fontWeight: 'bold',
  color: '#ffffff',
  fill: '#ffffff',
  fontSize: '16px',
  textDecoration: 'none',
  padding: '4px',
  verticalAlign: 'middle',
};

const SkipBarLinkStyle = cssClass(cssPrefix, 'link', {
  ...SkipBarLinkCSSProperties,
  $nest: {
    '&:focus': {
      ...PageHeaderStyles.ButtonFocus,
      ...SkipBarLinkCSSProperties,
    },
    '&.hover': {
      ...SkipBarLinkCSSProperties,
    },
    '&.active': {
      ...SkipBarLinkCSSProperties,
    },
    '&.visited': {
      ...SkipBarLinkCSSProperties,
    },
  },
});

const SkipBarArrowStyle = cssClass(cssPrefix, 'arrow', {
  marginLeft: '8px',
  verticalAlign: 'middle',
});

export interface SkipBarProps {
  readonly iframeSelector?: string;
  readonly contentSelector: string;
}

export interface SkipBarState {
  readonly opened: boolean;
}

export class SkipBar extends React.Component<SkipBarProps, SkipBarState> {
  constructor(props: SkipBarProps) {
    super(props);
    this.state = {
      opened: false,
    };
  }

  render() {
    // TFS942019 don't need alt text on icon if it repeats the text
    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
      <div className={this.state.opened ? SkipBarContainerOpenedStyle : SkipBarContainerStyle}>
        <a
          className={SkipBarLinkStyle}
          href="javascript:void(0)"
          onClick={this.onClick}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          {Messages.skipToContent()}
          <img className={SkipBarArrowStyle} alt={''} src={imgPath('skip_to_content_arrow.svg')}/>
        </a>
      </div>
    );
  }

  onClick = () => {
     if (this.props.iframeSelector) {
      const vizIsVisible = $(this.props.iframeSelector).length > 0;

      if (vizIsVisible) {
        $(this.props.iframeSelector)
          .focus()
          .contents()
          .find(this.props.contentSelector)
          .focus();
        return;
      }

      $(this.props.contentSelector).focus();
    }
  }

  onFocus = () => {
    this.setState({ opened: true });
  }

  onBlur = () => {
    this.setState({ opened: false });
  }
}
